let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kupZc")).then(() => parcelRequire('jARbM'));